/**
 * Performs setup related to Handlebars (registers helpers and partials)
 */
import Handlebars from 'handlebars/runtime'

import momentHelper from 'scoreboard/components/moment-helper'
import i18n from 'scoreboard/components/i18n'
import icon from 'scoreboard/components/icon'
import colorIcon from 'scoreboard/components/color-icon'
import constants from 'scoreboard/components/constants'
import sections from 'scoreboard/components/sections'
import minHeightVerticalCenterMsg from './components/min-height-vertical-center-msg.hbs'
import backwardForward from './components/backward-forward.hbs'
import tagsPanel from './components/tags-panel.hbs'
import { isV5, isV6 } from 'scoreboard/components/version'

function setupHandlebars() {
	// load handlebars helpers, e.g. {{i18n 'common.success'}}
	Handlebars.registerHelper('i18n', i18n.get.bind(i18n))
	Handlebars.registerHelper('i18nCount', (key,count) => i18n.countMessage(key,count))
	Handlebars.registerHelper('const', function(key) { return constants[key] })
	Handlebars.registerHelper('fromNow', momentHelper.fromNow.bind(momentHelper))
	Handlebars.registerHelper('formatDate', momentHelper.formatDate.bind(momentHelper))
	Handlebars.registerHelper('formatNumericDate', momentHelper.formatNumericDate.bind(momentHelper))
	Handlebars.registerHelper('formatTime', momentHelper.formatTime.bind(momentHelper))
	Handlebars.registerHelper('formatDateTime', date =>
		momentHelper.formatDateTime(date))
	Handlebars.registerHelper('icon', icon.bind(icon))
	Handlebars.registerHelper('colorIcon', colorIcon.bind(colorIcon))
	Handlebars.registerHelper('sectionToUrl', sections.toUrl)
	Handlebars.registerHelper('isV5', () => isV5())
	Handlebars.registerHelper('isV6', () => isV6())

	// Register partial (named) templates
	Handlebars.registerPartial({
		'min-height-vertical-center-msg': minHeightVerticalCenterMsg,
		'backward-forward': backwardForward,
		'tags-panel': tagsPanel
	})
}

export default setupHandlebars

setupHandlebars.__filename__ = 'setup-handlebars.js'
